// extracted by mini-css-extract-plugin
export default {"list":"DashboardGuide_list__hQ8Z8","icon":"DashboardGuide_icon__eKxMc"};